import {all, call, put, takeEvery} from 'redux-saga/effects';
import {
  TrackerPoliciesActionTypes,
  fetchError,
  fetchSuccess,
  updateSuccess,
  updateError
} from '@actions/tracker-policy';
import trackerPolicyApi from '@api/tracker-policy'
import {ReduxAction} from "@actions/index";

function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(trackerPolicyApi.getList, payload);
    yield put(fetchSuccess(res))
  } catch (err) {
    yield put(fetchError(err.stack!))
  }
}

function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(trackerPolicyApi.update, payload);
    yield put(updateSuccess(data))
  } catch (err) {
    yield put(updateError(err));
  }
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* trackerPolicySaga() {
  yield all([
    yield takeEvery(TrackerPoliciesActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(TrackerPoliciesActionTypes.UPDATE_REQUEST, handleUpdate),
  ])
}

export default trackerPolicySaga;
